import React, {Fragment} from 'react';
import {Props} from '../Builder/ElementProperties';
//import {TextField} from 'material-ui'

function autogrow(element) {
	if(element && element.style) {
    	element.style.height = "5px";
		element.style.height = (element.scrollHeight)+"px";
	}
}

class TextElement extends React.Component{

	componentDidMount(){
		autogrow(this.node);
		setTimeout(()=>{ autogrow(this.node) }, 100)
	}

	componentDidUpdate(){
		autogrow(this.node);
		setTimeout(()=>{ autogrow(this.node) }, 100)
	}

	render(){
		let props = this.props;
		let onClick;
		if(!props.builder){
			onClick = Props.onClickAreaHandler.bind(this, {props, elementType:'Text'});
		}

		return (
			<textarea
			ref={(n)=>{ this.node = n;}}	
			className="text-element"
				value={props.element.text || ''}
				onClick={onClick}
				onChange={ e => { 
					props.element.text = e.currentTarget.value;
					props.experiment.forceUpdate();
				}}
				readOnly={!props.builder}
				/>
		);
	}
} 

const Properties = (props) => (
	<Fragment>
		<Props.Id {...props} />
		<Props.X {...props} />
		<Props.Y {...props} />
		<Props.Width {...props} />
		<Props.Height {...props} />
		<Props.OnClick {...props} />
	</Fragment>
);

TextElement.type = 'text';
TextElement.Properties = Properties;
TextElement.defaultJSON = {type: 'text', id:'New Text', x: 210, y:0, width:200, height:50, text:'New Text', onClick:''};
export default TextElement;




// WEBPACK FOOTER //
// ./src/components/ScreenElements/TextElement.js